import { memo, useMemo } from 'react';
import { Box, Button, Text, Image } from '@betty/moonlight';
import { RegistrationStepProps } from '../RegistrationStep.types';
import { useSelector } from '@betty/toolkit/state';
import { selectRegistrationOffers } from '../../../state';

function IntroStep({ step, onSubmit }: RegistrationStepProps) {
  const offers = useSelector(selectRegistrationOffers);
  const bannerSrc = useMemo(() => {
    if (offers.length > 1) {
      return '/images/multi-banner.webp';
    }
    if (offers.length === 1) {
      return offers[0].bannerImageUrl;
    }

    return '/images/fallback-banner.webp';
  }, [offers]);

  return (
    <Box>
      <Image width="space-400" height="space-400" source={bannerSrc} />
      {step.stepTitleNS && step.stepTitleKey ? (
        <Text
          variant="h4"
          locNS={step.stepTitleNS}
          locKey={step.stepTitleKey}
        ></Text>
      ) : null}
      {step.stepDescriptionNS && step.stepDescriptionKey ? (
        <Text
          variant="body-m"
          locKey={step.stepDescriptionKey}
          locNS={step.stepDescriptionNS}
        ></Text>
      ) : null}
      <Button
        variant="primary"
        locNS="registration"
        locKey="nextButton"
        rightIcon="arrowForward"
        onPress={onSubmit}
      ></Button>
    </Box>
  );
}

export default memo(IntroStep);
